module.exports = __webpack_public_path__ + "img/marker.a6964c65.svg";